export const size = [
  { value: '1', displayName: '1' },
  { value: '2', displayName: '2' },
  { value: '3', displayName: '3' },
  { value: '4', displayName: '4' },
  { value: '5', displayName: '5' },
  { value: '6', displayName: '6' },
];

export const floors = [
  { value: '0-3', displayName: '0-3' },
  { value: '3+', displayName: '3+' },
];

export const squareMeters = [
  { value: '5-10', displayName: '5-10 m²' },
  { value: '10-15', displayName: '10-15 m²' },
  { value: '15-20', displayName: '15-20 m²' },
  { value: '20+', displayName: '20+ m²' },
];
